var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.5 31.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".envelope_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.25px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope_svg__mail-outline",
    transform: "translate(1.125 1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "envelope_svg__Path_9",
    d: "M6.188 6.75h23.625a2.813 2.813 0 0 1 2.812 2.813v16.875a2.813 2.813 0 0 1-2.812 2.812H6.188a2.813 2.813 0 0 1-2.813-2.812V9.563A2.813 2.813 0 0 1 6.188 6.75",
    className: "envelope_svg__cls-1",
    "data-name": "Path 9",
    transform: "translate(-3.375 -6.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "envelope_svg__Path_10",
    d: "M7.875 11.25 18 19.125l10.125-7.875",
    className: "envelope_svg__cls-1",
    "data-name": "Path 10",
    transform: "translate(-3.375 -6.75)"
  }))));
};
export default SvgEnvelope;